import React  from 'react';
import { ClayButtonWithIcon } from '@clayui/button';
import { ClayDropDownWithItems } from '@clayui/drop-down';
import ClayTable from '@clayui/table';
import { useHistory } from 'react-router-dom';
import { getCoordinationSettings } from '../../helpers/getCoordinationSettings';
import { getDetailCoordinationSettings } from '../../helpers/getDetailCoordinationSettings';
import { deleteCoordinationSettings } from '../../helpers/deleteCoordinationSettings';
import {invokews} from "../../helpers/invokews";

export const spritemap = window.location.protocol + '//' + window.location.host + '/o/classic-theme/images/clay/icons.svg';

export const CoordinationList = ({ cards, setCards, useExportModal, useImportModal }) => {

    const history = useHistory();

    const pushHistory = (url) => {
        history.push(url);
    };

    const changeState = (idSettings) => {
        if (confirm('¿Deseas cambiar el estado del registro?')) {
            
            const bodySend = {coordinationSettingId: idSettings};

            invokews('/digitalsale.deliverycoordinationsetting/update-state',
                bodySend ).then(respt => {

            });
        }
    }

    const deleteCard = (idSettings) => {
        if (confirm('¿Deseas eliminar este registro?')) {

            deleteCoordinationSettings({idSettings: idSettings}).then(respt => {

                if (respt.code == 1) {
                    getCoordinationSettings(10, 1).then(list => {
                        setCards(list);
                    });

                } else {
                    alert(respt.message);
                }
            });
        }
    }

    const { setExportModal } = useExportModal();
    const { setImportModal } = useImportModal();

    const showExportMessages = (detailCoordinationId) => {

        getDetailCoordinationSettings(detailCoordinationId).then(myobjet => {
            setExportModal({ visible: true, data: myobjet });
        });
    }

    const showImportMessages = (formCode) => {
        setImportModal({ visible: true, data: {}, formCode: formCode});
    }

    return (
        <div className="container-fluid-1280 sheet">
            <ClayTable hover={false}>
                <ClayTable.Head>
                    <ClayTable.Row>
                        <ClayTable.Cell headingCell>{"ID"}</ClayTable.Cell>
                        <ClayTable.Cell headingCell>{"Nombre"}</ClayTable.Cell>
                        <ClayTable.Cell headingCell>{"Activo"}</ClayTable.Cell>
                        <ClayTable.Cell headingCell>{""}</ClayTable.Cell>
                    </ClayTable.Row>
                </ClayTable.Head>
                <ClayTable.Body>
                    {
                        cards.data.map(card => (
                            <ClayTable.Row key={card.id}>
                                <ClayTable.Cell>{card.id}</ClayTable.Cell>
                                <ClayTable.Cell>{card.name}</ClayTable.Cell>
                                <ClayTable.Cell>
                                    <label className="toggle-switch">
                                        <input className="toggle-switch-check" defaultChecked={card.status} type="checkbox"
                                               onClick={() => changeState(card.id)}/>
                                        <span aria-hidden="true" className="toggle-switch-bar">
                                            <span className="toggle-switch-handle" data-label-off="No" data-label-on="Si"></span>
                                        </span>
                                    </label>
                                </ClayTable.Cell>
                                <ClayTable.Cell>
                                    <ClayDropDownWithItems
                                        items={[
                                            {
                                                label: "Editar",
                                                onClick: () => pushHistory(`detail/${card.id}`)
                                            },
                                            {
                                                label: "Exportar Mensajes",
                                                onClick: () => showExportMessages(card.id)
                                            },
                                            {
                                                label: "Importar Mensajes",
                                                onClick: () => showImportMessages(card.id)
                                            },
                                            {
                                                label: "Eliminar",
                                                onClick: () => deleteCard(card.id)
                                            }
                                        ]}

                                        spritemap={spritemap}
                                        trigger={
                                            <ClayButtonWithIcon
                                                displayType="unstyled"
                                                small
                                                spritemap={spritemap}
                                                symbol="ellipsis-v"
                                            />
                                        }
                                    />
                                </ClayTable.Cell>
                            </ClayTable.Row>
                        ))
                    }
                </ClayTable.Body>
            </ClayTable>
        </div>
    )
}
